import React from 'react';
import './LoadingUpload.css';

function LoadingUpload() {
  return (
    <div className="loading-upload">
      <div className="spinner-upload"></div>
      <p>Uploading documents to knowledge pack, please wait...</p>
    </div>
  );
}

export default LoadingUpload;
